const topbar = {
    docs: 'Docs',
    help: 'Help',
};
export default Object.freeze(topbar);
